<template>
  <div v-if="visible" class="iframe-redirect-overlay">
    <iframe
      name="paycore-redirect-iframe"
      class="iframe-redirect-overlay__frame"
      allow="payment"
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals"
      frameborder="0"
      allowfullscreen />
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    };
  },

  created() {
    this.$bus.$on('openIframeRedirect', this.open);
  },

  beforeDestroy() {
    this.$bus.$off('openIframeRedirect', this.open);
  },

  methods: {
    open() {
      this.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.iframe-redirect-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: #fff;

  &__frame {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }
}
</style>
